/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_Detail_Tournament_2_HeadingInputs */

const en_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-contraction reduction`)
};

const es_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reducción de la co-contracción`)
};

const de_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduzierung der Co-Kontraktion`)
};

const zh_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减少肌肉共同收缩`)
};

const ar_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقليل التقلص المشترك`)
};

const fr_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduction de la co-contraction`)
};

const vi_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm co đối kháng`)
};

const sw_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupunguza mkazo wa misuli pinzani kwa pamoja`)
};

const th_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การลดการหดตัวร่วมของกล้ามเนื้อ`)
};

const bs_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smanjenje ko-kontrakcije`)
};

const ja_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同時収縮を減らす`)
};

const ko_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동시 수축 줄이기`)
};

const pt_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redução da cocontração`)
};

const it_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridurre la co-contrazione`)
};

const sv_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minskad samkontraktion`)
};

const nl_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minder co-contractie`)
};

const da_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindre kokontraktion`)
};

const nb_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redusert samkontraksjon`)
};

const fi_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteissupistuksen vähentäminen`)
};

const pl_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograniczenie współskurczu`)
};

const ru_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снижение коконтракции`)
};

const tr_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko-kontraksiyonun azaltılması`)
};

const hi_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक साथ संकुचन को कम करना`)
};

const id_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengurangan ko-kontraksi`)
};

const ms_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengurangan ko-kontraksi`)
};

const cs_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omezení souběžné kontrakce`)
};

const el_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μείωση της συν-σύσπασης`)
};

const he_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפחתת כיווץ שרירים בו-זמני`)
};

const af_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermindering van mede-kontraksie`)
};

const hu_method_content_step_05_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ko-kontrakció csökkentése`)
};

/**
* | output |
* | --- |
* | "Co-contraction reduction" |
*
* @param {Method_Content_Step_05_Detail_Tournament_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_detail_tournament_2_heading = /** @type {((inputs?: Method_Content_Step_05_Detail_Tournament_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_Detail_Tournament_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "de") return de_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "th") return th_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "it") return it_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "da") return da_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "id") return id_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "el") return el_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "he") return he_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "af") return af_method_content_step_05_detail_tournament_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_05_detail_tournament_2_heading(inputs)
	return en_method_content_step_05_detail_tournament_2_heading(inputs)
});